export enum SeverityType {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
}
